import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "audioInput"
const AudioInputIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M20.368 12.196C21.06 12.03 21.75 12.555 21.75 13.29V19.573L21.74 19.722C21.64 20.459 20.81 21.034 19.8 21.034 18.724 21.034 17.851 20.38 17.851 19.573 17.851 18.765 18.724 18.11 19.801 18.11Q20.032 18.11 20.25 18.15V13.83L15.75 15.52V20.895Q15.765 20.982 15.765 21.07C15.765 21.878 14.892 22.532 13.815 22.532S11.868 21.878 11.868 21.07 12.739 19.608 13.816 19.608Q14.04 19.608 14.25 19.645V15.26C14.25 14.791 14.541 14.371 14.98 14.207L20.23 12.238z" />
          <path
            fillRule="evenodd"
            d="M7.875 1.5C8.496 1.5 9 2.004 9 2.625V6H12V15.75H11.982C11.827 17.471 10.615 18.886 9 19.343V22.5H6.75V19.343C5.135 18.886 3.923 17.471 3.768 15.75H3.75V6H6.75V2.625C6.75 2.004 7.254 1.5 7.875 1.5M5.276 15.75C5.458 17.022 6.553 18 7.875 18S10.291 17.022 10.473 15.75zM5.25 14.25H10.5V7.5H5.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AudioInputIcon
